import { Container, Grid, Typography, Paper, Accordion, AccordionDetails, AccordionSummary, Box, Dialog, DialogActions, DialogContent, DialogContentText, Slide } from '@mui/material';
import React, { useEffect, useState } from 'react';
import BlueButton from '../../components/blueButton';
import RedButton from '../../components/redButton';
import { Helmet } from 'react-helmet';
import globals from '../../globals';
import AccessibilityNewSharpIcon from '@mui/icons-material/AccessibilityNewSharp';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ErrorIcon from '@mui/icons-material/Error';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import FacebookIcon from '@mui/icons-material/Facebook';
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const mondaySlots = [
    { heading: '09:00 – 09:20 Игра за запознанство', items: ['„Кажи името си и любимото си животно“', 'Правила на занималнята'] },
    { heading: '09:20 – 10:00 Български език', items: ['Лятно четене', 'Игра: „Познай думата“', 'Кратък разказ по картинка'] },
    { heading: '10:00 – 10:15 Движение и почивка', items: ['Танц с музика', 'Разтягане'] },
    { heading: '10:15 – 11:00 Математика', items: ['Забавни сметки', 'Онлайн викторина', '„Математическо бинго“'] },
    { heading: '11:00 – 11:30 Творческа задача „Нарисувай своето лято“', items: [] },
    { heading: '11:30 – 12:00 Финална игра', items: ['„Покажи предмет в любим цвят“', 'Споделяне и награди'] },
];

const tuesdaySlots = [
    { heading: '09:00 – 09:15 Интересен факт на деня', items: [] },
    { heading: '09:15 – 10:00 Четене с разбиране', items: ['Текст: „Пътешествие около света“'] },
    { heading: '10:00 – 10:15 Движение', items: ['Игра „Замръзни“'] },
    { heading: '10:15 – 11:00 Логически задачи', items: ['Загадки', 'Судоку за деца', 'Открий разликите'] },
    { heading: '11:00 – 11:30 Мини експеримент „Дъга в чаша“', items: [] },
    { heading: '11:30 – 12:00 Kahoot викторина', items: [] },
];

const wednesdaySlots = [
    { heading: '09:00 – 09:20 Забавна игра „Ако бях супергерой...“', items: [] },
    { heading: '09:20 – 10:00 Български език', items: ['Съчиняване на кратка приказка', 'Измисли герой'] },
    { heading: '10:00 – 10:15 Танцувална почивка', items: [] },
    { heading: '10:15 – 11:00 Математически игри', items: ['Пъзели', 'Работа по двойки'] },
    { heading: '11:00 – 11:30 Арт работилница', items: ['Изработка на книжка или комикс'] },
    { heading: '11:30 – 12:00 Представяне на творбите', items: [] },
];

const thursdaySlots = [
    { heading: '09:00 – 09:15 Разговор: „Как пазим природата?“', items: [] },
    { heading: '09:15 – 10:00 Четене и обсъждане', items: ['Тема: животни и природа'] },
    { heading: '10:00 – 10:15 Активна почивка', items: [] },
    { heading: '10:15 – 11:00 Математика', items: ['Задачи с картинки', 'Състезание по бързо мислене'] },
    { heading: '11:00 – 11:30 Експеримент „Вулкан със сода и оцет“', items: [] },
    { heading: '11:30 – 12:00 Игра „Познай животното“', items: [] },
];

const fridaySlots = [
    { heading: '09:00 – 09:20 Музикално начало', items: [] },
    { heading: '09:20 – 10:00 Лятна викторина', items: ['Български език', 'Математика', 'Логически въпроси'] },
    { heading: '10:00 – 10:15 Танцово междучасие', items: [] },
    { heading: '10:15 – 11:00 Отборни игри', items: [] },
    { heading: '11:00 – 11:30 „Покажи своя талант“', items: ['Песен', 'Рисунка', 'Танц', 'Рецитал'] },
    { heading: '11:30 – 12:00 Финал на седмицата', items: ['Похвали', 'Виртуални грамоти', 'Снимка на групата'] },
];

const weeklyProgram = [
    { day: 'Понеделник', slots: mondaySlots },
    { day: 'Вторник', slots: tuesdaySlots },
    { day: 'Сряда', slots: wednesdaySlots },
    { day: 'Четвъртък', slots: thursdaySlots },
    { day: 'Петък', slots: fridaySlots },
];

const getTimeLeft = () => {
    const targetDate = new Date('2026-05-17T23:59:59');
    const now = new Date();
    const difference = targetDate.getTime() - now.getTime();

    if (difference <= 0) return { isPast: true, days: 0, hours: 0, minutes: 0 };

    const totalMinutes = Math.floor(difference / (1000 * 60));
    const days = Math.floor(totalMinutes / (60 * 24));
    const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
    const minutes = totalMinutes % 60;

    return { isPast: false, days, hours, minutes };
};

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const SummerSchoolPage = () => {
    const [timeLeft, setTimeLeft] = useState(getTimeLeft());
    const [hasExistingParticipation, setHasExistingParticipation] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const navigate = useNavigate();
    const { user, token } = useAuth();

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeLeft(getTimeLeft());
        }, 1000 * 60);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (!token) {
            setHasExistingParticipation(false);
            return;
        }

        async function checkExistingParticipation() {
            try {
                const response = await fetch(`${globals.apiUrl}/competitions/participation`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (!response.ok) {
                    setHasExistingParticipation(false);
                    return;
                }

                const data = await response.json();
                setHasExistingParticipation((data?.participations?.length || 0) > 0);
            } catch {
                setHasExistingParticipation(false);
            }
        }

        checkExistingParticipation();
    }, [token]);

    const goToCheckout = () => {
        if (user) {
            navigate('/summer-school/checkout');
            return;
        }
        setOpenDialog(true);
    };

    const handleClose = () => setOpenDialog(false);

    const handleConfirm = () => {
        navigate(`/login?redirect=${encodeURIComponent('/summer-school/checkout')}`);
    };

    const priceCard = (
        <Paper sx={{ borderRadius: 2, mt: 3, py: 3, px: 1 }} elevation={4}>
            <Grid container justifyContent={'center'} alignItems={'center'} spacing={1} textAlign={'center'}>
                <Grid item>
                    <RedButton
                        text="Купи"
                        size={'large'}
                        pX={4}
                        startIcon={<ShoppingCartIcon />}
                        sx={{ fontSize: 20, py: 1.2 }}
                        onClick={goToCheckout}
                    />
                </Grid>
                <Grid item>
                    <Typography component="span" sx={{ fontWeight: 'bold', fontSize: 28, color: globals.colors.darkBlue }}>€120 </Typography>
                </Grid>
            </Grid>
        </Paper>
    );

    return (

        <Container maxWidth='lg'>
            {/* <Helmet>
                <title>Пробна матура по математика за 7 клас онлайн</title>
                <meta name="description" content="Онлайн пробна матура по математика за 7 клас по формата на НВО от eAcademiaBg . Провери нивото си, открий пропуските и се подготви ефективно за изпита." />
                <meta
                    property="og:title"
                    content="Пробна матура по математика за 7 клас онлайн"
                />
                <meta
                    property="og:description"
                    content="Онлайн пробна матура по математика за 7 клас по формата на НВО от eAcademiaBg. Провери нивото си, открий пропуските и се подготви ефективно за изпита."
                />
            </Helmet> */}
            <Grid container justifyContent={'center'} textAlign={'center'} spacing={2} direction={'column'}>
                <Grid item>
                    <img src="https://eacademiabg-test.s3.us-east-1.amazonaws.com/summer_school/summer_school.png" style={{ height: '23vw', width: 'auto' }} />
                </Grid>
                <Grid item>
                    <Typography sx={{ fontWeight: 'bold', fontSize: 30, color: globals.colors.lightRed }}>Онлайн седмична лятна занималня
                        за ученици в 3. и 4. клас - <a style={{ color: globals.colors.darkRed }}>август 2026</a></Typography>
                </Grid>
            </Grid>

            {priceCard}

            <Paper sx={{ borderRadius: 2, mt: 3, py: 2, px: { xs: 2, sm: 4 }, backgroundColor: globals.colors.darkBlue }} elevation={4}>
                <Grid container justifyContent={'space-around'} alignItems={'flex-start'} spacing={3} textAlign={'center'}>
                    {[
                        { icon: '/summer_icon_1.png', label: 'Изцяло онлайн занимания в zoom' },
                        { icon: '/summer_icon_2.png', label: 'Индивидуален подход в малки групи' },
                        { icon: '/summer_icon_3.png', label: 'Ползотворна седмица с игри и знания' },
                    ].map((feature) => (
                        <Grid item xs={12} sm={4} key={feature.label}>
                            <img src={feature.icon} alt='' style={{ height: 100, width: 'auto' }} />
                            <Typography sx={{ color: 'white', fontWeight: 'bold', fontSize: 18, mt: 1 }}>{feature.label}</Typography>
                        </Grid>
                    ))}
                </Grid>
            </Paper>

            <Paper sx={{ borderRadius: 2, mt: 3, py: 1, px: 2 }} elevation={4}>
                <Grid id="what-is-the-competition" container justifyContent={'center'} alignItems={'center'}>
                    <Grid item textAlign={'center'}>
                        <Typography sx={{ fontSize: 19, color: globals.colors.lightRed, fontWeight: 'bold' }}>Какво представлява лятната занималня?</Typography>
                    </Grid>
                    <Grid item xs={12} textAlign={'left'}>
                        <Typography
                            sx={{ fontSize: 16, mt: 1 }}
                            dangerouslySetInnerHTML={{
                                __html: `През месец август организираме седмична лятна онлайн занималня за ученици в <strong>3. и 4. клас</strong>. Всяка седмица следва една и съща програма,
                                така че можете да изберете най-удобния за вашето семейство период без да пропускате съдържание. <br /><br />
                                <strong>Възможни периоди за записване:
                                <ul>
                                    <li>03 – 07 август</li>
                                    <li>10 – 14 август</li>
                                    <li><span style="text-decoration: line-through;">17 – 21 август</span> <span style="color: ${globals.colors.lightRed};">запълнен</span></li>
                                    <li>24 – 28 август</li>
                                </ul></strong>
                                
                                <br />
                                Занималнята съчетава учене, творчество и забавление в подкрепяща среда:
                                <ul>
                                    <li>поддържане на знанията по български език и математика</li>
                                    <li>логически игри, творчески дейности и интересни предизвикателства</li>
                                    <li>общуване, работа в екип и създаване на нови приятелства</li>
                                    <li>индивидуален подход към всяко дете</li>
                                    <li>спокойна подготовка за новата учебна година</li>
                                </ul>`,
                            }}
                        />
                    </Grid>
                </Grid>
            </Paper>

            <Paper sx={{ borderRadius: 2, mt: 5, py: 1, px: 2 }} elevation={4}>
                <Grid container id="how-to-participate" justifyContent={'space-around'} textAlign={'center'}>
                    <Grid item xs={12} sm={5}>
                        <Grid container textAlign={'left'} alignItems={'center'}>
                            <Grid item>
                                <Typography sx={{ fontSize: 19, color: globals.colors.lightRed, fontWeight: 'bold', mb: 2, mt: 2 }}>За водещия на занималнята</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography
                                    component="div"
                                    dangerouslySetInnerHTML={{
                                        __html: `
                                    <a href='https://eacademiabg.com/instructor/404' style='text-decoration: none; color: inherit;'><strong>Анна Бисет-Рибарова</strong></a> е специалист по детско развитие, начална педагогика и ерготерапия с международен опит.
                                    <br /><br />Тя създава подкрепяща и приобщаваща среда, в която всяко дете може да учи, да се развива и да разгърне своя потенциал.`,
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={5}>
                        <img src='https://eacademiabg-test.s3.us-east-1.amazonaws.com/summer_school/Anna-Bisset+(1).jpeg' style={{ height: 250, width: 'auto', marginTop: 5 }} />
                    </Grid>
                </Grid>
            </Paper>

            <Paper sx={{ borderRadius: 2, mt: 5, py: 2, px: 2 }} elevation={4}>
                <Grid id="weekly-program" container justifyContent={'center'}>
                    <Grid item xs={12} textAlign={'center'}>
                        <Typography sx={{ fontSize: 19, color: globals.colors.lightRed, fontWeight: 'bold', mb: 2 }}>Седмична програма</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        {weeklyProgram.map((day, index) => (
                            <Accordion key={day.day} sx={{ borderRadius: 2, mb: 1, '&:before': { display: 'none' } }}>
                                <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: globals.colors.lightRed }} />}>
                                    <Typography sx={{ fontSize: 20, color: globals.colors.lightRed, fontWeight: 'bold' }}>{day.day}</Typography>
                                </AccordionSummary>
                                <AccordionDetails sx={{ textAlign: 'center' }}>
                                    <Box sx={{ display: 'inline-block', textAlign: 'left' }}>
                                        {day.slots.map((slot) => (
                                            <Grid key={slot.heading} sx={{ mb: 2 }}>
                                                <Typography sx={{ fontSize: 16, color: globals.colors.lightRed, fontWeight: 'bold' }}>{slot.heading}</Typography>
                                                {slot.items.length > 0 && (
                                                    <ul style={{ margin: '4px 0 0 0', paddingLeft: 24 }}>
                                                        {slot.items.map((item) => (
                                                            <li key={item} style={{ fontSize: 16, color: globals.colors.textColor }}>{item}</li>
                                                        ))}
                                                    </ul>
                                                )}
                                            </Grid>
                                        ))}
                                    </Box>
                                </AccordionDetails>
                            </Accordion>
                        ))}
                    </Grid>
                </Grid>
            </Paper>

            <Paper sx={{ borderRadius: 2, py: 1, px: 2, height: '100%', mt: 4, boxSizing: 'border-box', display: 'flex', justifyContent: 'center' }} elevation={4}>
                <Grid id="how-to-enroll" container justifyContent={'space-between'} sx={{ mt: 1, mb: 1 }} alignItems={'center'}>
                    <Grid item xs={12} sm={8}>
                        <Grid container textAlign={'left'}>
                            <Grid item xs={12}>
                                <Typography sx={{ fontSize: 19, color: globals.colors.lightRed, fontWeight: 'bold', mb: 2 }}>Записване в занималнята</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <ol style={{ paddingLeft: 20, margin: 0 }}>
                                    <li style={{ fontSize: 16, marginBottom: 12 }}>Кликнете на бутона „Купи“, това ще ви прехвърли в страница за регистрация на платформата.</li>
                                    <li style={{ fontSize: 16, marginBottom: 12 }}>Изберете седмицата от месец август, в която детето ще участва.</li>
                                    <li style={{ fontSize: 16, marginBottom: 12 }}>Преминете към плащане.</li>
                                    <li style={{ fontSize: 16, marginBottom: 12 }}>След успешно заплащане ще получите имейл с повече информация и линк за достъп до Zoom.</li>
                                </ol>
                                <Typography sx={{ fontSize: 12, mt: 1, fontWeight: 'bold' }}>(Един закупен достъп важи за 1 дете от 1 устройство. Не се допуска участие на повече от 1 дете с един достъп.)</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={4} sx={{ textAlign: { xs: 'center', sm: 'right' } }}>
                        <img src='/summer_school.png' style={{ width: '15vw', height: 'auto', maxWidth: 500, borderRadius: 8 }} />
                    </Grid>
                </Grid>
            </Paper>

            <Grid container wrap='nowrap' spacing={1} sx={{ mt: 2 }}>
                <Grid item>
                    <ErrorIcon sx={{ color: globals.colors.lightRed }} />
                </Grid>
                <Grid item>
                    <Typography sx={{ fontSize: 15 }}>
                        <strong>Всяка седмица се провежда при минимум 3 записани деца.</strong><br />
                        При недостатъчен брой записани участници eAcademiaBg си запазва правото да отмени провеждането на съответната седмица. В такъв случай родителите ще бъдат уведомени своевременно и ще могат да изберат друга седмица или да получат възстановяване на заплатената сума. При отказ от участие или неявяване на записан ученик, за които eAcademiaBg не е уведомена писмено най-късно 24 часа преди началото на съответната седмица, заплатената сума не подлежи на възстановяване.
                    </Typography>
                </Grid>
            </Grid>

            {priceCard}

            <Paper sx={{ borderRadius: 2, mt: 5, mb: 5, py: 3, px: 4, backgroundColor: globals.colors.darkBlue }} elevation={4}>
                <Typography sx={{ color: 'white', fontSize: 18, mb: 3 }}>При въпроси или нужда от съдействие, свържете се с нас:</Typography>
                <Grid container spacing={2} alignItems={'center'} justifyContent={'space-between'}>
                    <Grid item xs={12} sm={'auto'}>
                        <Grid container alignItems={'center'} spacing={1} wrap='nowrap'>
                            <Grid item><EmailIcon sx={{ color: globals.colors.lightRed, display: 'block' }} /></Grid>
                            <Grid item><Typography component='a' href='mailto:info@eacademiabg.com' sx={{ color: 'white', textDecoration: 'none' }}>info@eacademiabg.com</Typography></Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={'auto'}>
                        <Grid container alignItems={'center'} spacing={1} wrap='nowrap'>
                            <Grid item><PhoneIcon sx={{ color: globals.colors.lightRed, display: 'block' }} /></Grid>
                            <Grid item><Typography component='a' href='tel:+359878852548' sx={{ color: 'white', textDecoration: 'none' }}>+359 87 885 2548</Typography></Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={'auto'}>
                        <Grid container alignItems={'center'} spacing={1} wrap='nowrap'>
                            <Grid item><FacebookIcon sx={{ color: globals.colors.lightRed, display: 'block' }} /></Grid>
                            <Grid item><Typography component='a' href='https://www.facebook.com/EAcademiaBg' target='_blank' rel='noopener noreferrer' sx={{ color: 'white', textDecoration: 'none' }}>EAcademiaBg</Typography></Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Paper>

            <Dialog
                open={openDialog}
                slots={{ transition: Transition }}
                keepMounted
                onClose={handleClose}
                aria-describedby="account-dialog-slide-description"
            >
                <DialogContent>
                    <DialogContentText id="account-dialog-slide-description">
                        <Grid container justifyContent="center" textAlign="center">
                            <Grid item>
                                <Typography sx={{ fontSize: 17, color: globals.colors.darkBlue, fontWeight: 'bold' }}>
                                    За да запишете детето си в лятната занималня, е необходима регистрация или вход в платформата.
                                </Typography>
                            </Grid>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <BlueButton onClick={handleClose} sx={{ textTransform: 'capitalize', fontWeight: 'bold', fontSize: 16, width: 120 }} text="Откажи" />
                    <RedButton
                        onClick={handleConfirm}
                        text="Продължи"
                        sx={{ textTransform: 'capitalize', fontWeight: 'bold', fontSize: 16, width: 120 }}
                    />
                </DialogActions>
            </Dialog>
        </Container >
    );
}

export default SummerSchoolPage
